import { render, staticRenderFns } from "./CurriculumSUnits.vue?vue&type=template&id=d008661c&scoped=true&lang=pug&"
import script from "./CurriculumSUnits.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSUnits.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSUnits.vue?vue&type=style&index=0&id=d008661c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d008661c",
  null
  
)

export default component.exports